import { z } from "zod";

export const TonConnectPayloadSchema = z.object({
  payload: z.string(),
});

export type TonConnectPayloadDto = z.infer<typeof TonConnectPayloadSchema>;

export const TonConnectProofSchema = z.object({
  id: z.string(),
  wallet: z.string(),
  accessToken: z.string(),
});

export type TonConnectProofDto = z.infer<typeof TonConnectProofSchema>;
